import request from '@/API/request';

// 页面访问埋点
export function trackSimpleVisit(data) {
  return request({
    url: '/track/api/simple-visit',
    method: 'post',
    data,
  });
}

// 用户登录埋点
export function trackUserLogin(data) {
  return request({
    url: '/track/api/user-login',
    method: 'post',
    data,
  });
}